import { useState, useCallback, type ReactNode } from 'react';
import ReactModal from 'react-modal';
import CIcon from '@coreui/icons-react';
import { cilX } from '@coreui/icons';
import styles from './Modal.module.scss';

// #root is in index.html before the bundle, so it exists when this module runs.
const appElement = document.getElementById('root');
if (appElement) ReactModal.setAppElement(appElement);

/** Nothing shown yet, or hidden again. */
type TNoModalProps = Record<string, never>;

/**
 * The modal state; `showModal` keeps what it is called with as `modalProps` (an object or the HTML of a message).
 */
export const useModal = <TModalProps = TNoModalProps,>() => {
  const [isVisible, setIsVisible] = useState(false);
  const [modalProps, setModalProps] = useState<TModalProps | TNoModalProps>({});

  const showModal = useCallback((data: TModalProps | TNoModalProps = {}) => {
    setModalProps(data);
    setIsVisible(true);
  }, []);

  const hideModal = useCallback(() => {
    setIsVisible(false);
    setModalProps({});
  }, []);

  return { showModal, hideModal, modalProps, isVisible };
};

const customStyles = {
  content: {
    // width: '50%',
    // height: '50%',
    // top: '50%',
    // left: '50%',
    // right: 'auto',
    // bottom: 'auto',
  },
};

interface IModalProps {
  children?: ReactNode;
  isVisible: boolean;
  close: () => void;
  header?: ReactNode;
  modalStyle?: ReactModal.Styles;
}

const Modal = ({ children, isVisible, close, header, modalStyle = {} }: IModalProps) => (
  <ReactModal
    isOpen={isVisible}
    onRequestClose={close}
    style={{ ...customStyles, ...modalStyle }}
    bodyOpenClassName={styles.bodyOpen}
    className={{
      base: styles.modal,
      afterOpen: styles.modalAfterOpen,
      beforeClose: styles.modalBeforeClose,
    }}
    overlayClassName={{
      base: styles.overlay,
      afterOpen: styles.overlayAfterOpen,
      beforeClose: styles.overlayBeforeClose,
    }}
    closeTimeoutMS={300}
  >
    <div className={styles.modalHeader}>
      {header ? <h4 className="my-3">{header}</h4> : null}
      <button type="button" className={styles.modalCloseButton} onClick={close}>
        <CIcon icon={cilX} />
      </button>
    </div>
    <div className={styles.modalBody}>{children}</div>
  </ReactModal>
);

export default Modal;
